import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Download, CheckCircle, Loader2, ArrowLeft, FileVideo, Info, Building2 } from "lucide-react";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";

// Import your logo
import digikoreLogo from "../../assets/digikorestudios.png";
import { useDispatch, useSelector } from "react-redux";
import { downloadCollageById, getCollageById } from "../../redux/reduxSlices/collageSlice";

const CollageDownloadPage = () => {
    const { id } = useParams();
    const dispatch = useDispatch()
    const { loading } = useSelector((state) => state.collage);

    useEffect(() => {
        dispatch(getCollageById(id))
    }, [])


    useEffect(() => {
        const isMobile = () =>
            /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent) ||
            window.innerWidth < 768;

        // ✅ Don't run any DevTools / Inspect blocking on mobile
        if (isMobile()) return;

        const handleKeyDown = (e) => {
            if (
                e.keyCode === 123 ||
                (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J")) ||
                (e.ctrlKey && e.key === "u")
            ) {
                e.preventDefault();
                alert("Inspect is disabled on this page.");
            }
        };

        const handleContextMenu = (e) => e.preventDefault();

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("contextmenu", handleContextMenu);

        const threshold = 160;
        const checkDevTools = setInterval(() => {
            const widthGap = window.outerWidth - window.innerWidth;
            const heightGap = window.outerHeight - window.innerHeight;

            if (widthGap > threshold || heightGap > threshold) {
                alert("Developer tools detected! Please close them to continue.");
                window.location.reload();
            }
        }, 1000);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("contextmenu", handleContextMenu);
            clearInterval(checkDevTools);
        };
    }, []);



    const downloadFromUrl = async () => {
        try {
            const action = await dispatch(downloadCollageById(id));
            const { blob, contentType } = action.payload;

            // Use the blob directly
            const videoBlob = blob instanceof Blob ? blob : new Blob([blob], { type: contentType || "video/mp4" });

            const url = window.URL.createObjectURL(videoBlob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "collage.mp4"; // include extension
            document.body.appendChild(a);
            a.click();
            a.remove();

            // delay revoke
            setTimeout(() => window.URL.revokeObjectURL(url), 1500);
        } catch (error) {
            console.log("error", error);
        }
    };


    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 p-4">
            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 4000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                    },
                    success: {
                        iconTheme: {
                            primary: '#10B981',
                            secondary: '#fff',
                        },
                    },
                }}
            />

            <div className="max-w-4xl mx-auto">
                {/* Header Logo & Title */}
                <div className="flex flex-col items-center justify-center mb-8 mt-6">
                    <img
                        src={digikoreLogo}
                        alt="Digikore Logo"
                        className="h-12 mb-6 w-48"
                    />
                    <div className="text-center">
                        <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent mb-2">
                            Your Collage Video is Ready!
                        </h1>
                        <p className="text-gray-600 text-sm">
                            Download your custom collage with audio
                        </p>
                    </div>


                </div>

                {/* Main Content */}
                <div className="flex flex-col lg:flex-row justify-center items-start gap-8 max-w-4xl mx-auto px-4">


                    {/* Right Column - Download Section */}
                    <div className="bg-white rounded-2xl shadow-xl p-8 w-full lg:max-w-md">
                        <div className="text-center mb-6">
                            <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-r from-purple-100 to-blue-100 rounded-full flex items-center justify-center">
                                <FileVideo className="w-10 h-10 text-purple-600" />
                            </div>
                            <h2 className="text-xl font-bold text-gray-800 mb-2">
                                Download Your Collage Video
                            </h2>
                            <p className="text-gray-500 text-sm">
                                Your custom video collage is ready
                            </p>
                        </div>

                        {/* Download Button */}
                        <div className="text-center">
                            <button
                                onClick={downloadFromUrl}
                                disabled={loading}
                                className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-semibold py-4 px-10 rounded-xl text-lg max-md:text-sm shadow-lg hover:shadow-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-lg flex items-center justify-center gap-3 w-full"
                            >
                                {loading ? (
                                    <>
                                        <Loader2 className="w-6 h-6 animate-spin" />
                                        Preparing Download...
                                    </>
                                ) : (
                                    <>
                                        <Download className="w-6 h-6" />
                                        Download Video
                                    </>
                                )}
                            </button>
                        </div>



                        {/* Hidden Audio Element (for consistency with theme) */}
                        <div className="hidden">
                            <FileVideo className="w-4 h-4" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CollageDownloadPage;